import React from 'react';

import {MultiValueLabel} from 'react-select/lib/components/MultiValue';
import SingleValue from 'react-select/lib/components/SingleValue';

import {renderIcon} from './utils';

import type {ExtraPropsType} from '../SweetReactSelect';
import type {ValueType} from 'react-select';

interface Props<IT> {
  data: IT | Array<IT> | ValueType<IT> | ValueType<Array<IT>>;
  selectProps: {
    extraProps?: ExtraPropsType<IT>;
  };
}

export function SelectMultiValueLabel<IT>({
  data: item,
  selectProps,
  ...other
}: Props<IT>) {
  const {typeIcon} = selectProps.extraProps || {};
  const icon = renderIcon(typeIcon, item);

  return icon != null ? (
    <div
      className="d-flex align-items-center"
      style={{
        overflow: 'hidden',
      }}
    >
      <i className={`ml-1 ${icon} fa-xs`} />
      <MultiValueLabel {...other} />
    </div>
  ) : (
    <MultiValueLabel {...other} />
  );
}

export function SelectSingleValue<IT>({
  data: item,
  selectProps,
  ...other
}: Props<IT>) {
  const {typeIcon} = selectProps.extraProps || {};
  const icon = renderIcon(typeIcon, item);

  return icon != null ? (
    <div className="d-flex">
      <i className={`fa-fw ${icon}`} />{' '}
      <div>
        <SingleValue {...other} />
      </div>
    </div>
  ) : (
    <SingleValue {...other} />
  );
}
